// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__3-kCq","input":"TextArea_input__2RQ88","charsLeft":"TextArea_charsLeft__2ChiG","fresh":"TextArea_fresh__eUHPZ"};